import { Button, Checkbox, Modal } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useState } from 'react';

import {
  RELEASE_NOTE_POPUP_DISMISSED_KEY,
  useGetPendingPopupQuery,
  useMarkPopupShownMutation,
  useMarkReleaseNoteReadMutation,
} from '../../../services/releaseNotesApi';
import { ReleaseNoteView } from './ReleaseNoteView';
import { PopupCheckboxRow } from './styles';

function readDismissedIds(): number[] {
  try {
    const raw = localStorage.getItem(RELEASE_NOTE_POPUP_DISMISSED_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function ReleaseNotesPopup() {
  const [dismissedIds, setDismissedIds] = useState<number[]>(readDismissedIds);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const { data: releaseNote } = useGetPendingPopupQuery();
  const [markPopupShown] = useMarkPopupShownMutation();
  const [markRead] = useMarkReleaseNoteReadMutation();

  function dismissForSession(id: number) {
    const next = Array.from(new Set([...dismissedIds, id]));
    localStorage.setItem(
      RELEASE_NOTE_POPUP_DISMISSED_KEY,
      JSON.stringify(next)
    );
    setDismissedIds(next);
  }

  function handleUnderstood() {
    if (!releaseNote) {
      return;
    }
    if (dontShowAgain) {
      markPopupShown(releaseNote.id);
    } else {
      markRead(releaseNote.id);
    }
    dismissForSession(releaseNote.id);
  }

  if (!releaseNote) {
    return null;
  }

  const visible = !dismissedIds.includes(releaseNote.id);

  return (
    <Modal
      title={`Novidades — PMIS ${releaseNote.version}`}
      visible={visible}
      onCancel={() => dismissForSession(releaseNote.id)}
      footer={[
        <Button key="ok" type="primary" onClick={handleUnderstood}>
          Entendi
        </Button>,
      ]}
      width={740}
      bodyStyle={{
        maxHeight: 'calc(100vh - 240px)',
        overflowY: 'auto',
        paddingRight: 28,
      }}
    >
      <ReleaseNoteView releaseNote={releaseNote} />
      <PopupCheckboxRow>
        <Checkbox
          checked={dontShowAgain}
          onChange={(e: CheckboxChangeEvent) =>
            setDontShowAgain(e.target.checked)
          }
        >
          Não exibir este aviso novamente
        </Checkbox>
      </PopupCheckboxRow>
    </Modal>
  );
}
